var _circle, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInternetComputer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 11,
    r: 10,
    fill: "#FAFAFA"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2895_13541)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.5975 8C13.8172 8 12.9626 8.42531 12.0613 9.26421C11.636 9.65831 11.2614 10.0875 10.9883 10.427C10.9883 10.427 11.4253 10.9303 11.9052 11.4727C12.1667 11.1449 12.5373 10.7001 12.9704 10.2982C13.7703 9.54905 14.2932 9.39688 14.5936 9.39688C15.7174 9.39688 16.6304 10.3411 16.6304 11.5078C16.6304 12.6628 15.7174 13.607 14.5936 13.6187C14.539 13.6187 14.4766 13.6109 14.3985 13.5953C14.7263 13.7475 15.0814 13.8567 15.413 13.8567C17.4732 13.8567 17.879 12.4326 17.9024 12.3311C17.961 12.0697 17.9961 11.7965 17.9961 11.5156C17.9922 9.57637 16.4704 8 14.5975 8Z",
    fill: "url(#paint0_linear_2895_13541)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.39855 15.0156C8.17893 15.0156 9.03345 14.5903 9.93478 13.7514C10.3601 13.3573 10.7347 12.9281 11.0078 12.5886C11.0078 12.5886 10.5708 12.0852 10.0909 11.5429C9.82943 11.8706 9.45875 12.3155 9.02564 12.7174C8.22575 13.4587 7.699 13.6187 7.40245 13.6187C6.27871 13.6187 5.36566 12.6744 5.36566 11.5078C5.36566 10.3528 6.27871 9.40854 7.40245 9.39684C7.45708 9.39684 7.51951 9.40464 7.59755 9.42025C7.26979 9.26807 6.91472 9.15882 6.58305 9.15882C4.52285 9.15492 4.11706 10.5791 4.09365 10.6845C4.03512 10.9459 4 11.219 4 11.5C4 13.4392 5.52174 15.0156 7.39855 15.0156Z",
    fill: "url(#paint1_linear_2895_13541)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.96723 10.3294C8.74092 10.1109 7.64059 9.21739 6.58707 9.18618C4.70636 9.13935 4.15619 10.505 4.10547 10.6806C4.46835 9.15106 5.8106 8.0078 7.40257 8C8.7019 8 10.0168 9.27592 10.9884 10.427L10.9923 10.4231C10.9923 10.4231 11.4293 10.9264 11.9093 11.4688C11.9093 11.4688 12.4555 12.1126 13.033 12.6784C13.2593 12.8969 14.3557 13.7787 15.4093 13.8099C17.3407 13.8645 17.8753 12.4208 17.9026 12.3116C17.5475 13.8528 16.2013 15 14.6016 15.0078C13.3022 15.0078 11.9873 13.7319 11.0118 12.5808C11.0118 12.5847 11.0079 12.5847 11.0079 12.5886C11.0079 12.5886 10.5709 12.0853 10.091 11.5429C10.0949 11.5429 9.54861 10.8952 8.96723 10.3294ZM4.10547 10.6962C4.10547 10.6923 4.10547 10.6884 4.10937 10.6845C4.10547 10.6884 4.10547 10.6923 4.10547 10.6962Z",
    fill: "#29ABE2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2895_13541",
    x1: 12.7709,
    y1: 8.55588,
    x2: 17.5812,
    y2: 13.4058,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#F15A24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6841,
    stopColor: "#FBB03B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2895_13541",
    x1: 9.22644,
    y1: 14.4605,
    x2: 4.41615,
    y2: 9.6106,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#ED1E79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8929,
    stopColor: "#522785"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2895_13541"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 7.01561,
    fill: "white",
    transform: "translate(4 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInternetComputer);
export default __webpack_public_path__ + "static/media/InternetComputer.2ab46aed8e88d842e13d3dee004ddf6a.svg";
export { ForwardRef as ReactComponent };